let state = {
  projectTypeCreated: [],
  typeExportPdf: '',
};

const mutations = {
  SET_TYPE_EXPORT_PDF(state, type) {
    state.typeExportPdf = type;
  },
};

const actions = {
  updateTypeExportPdf({ commit }, type) {
    commit('SET_TYPE_EXPORT_PDF', type);
  },
};

const getters = {
  typeExportPdf(state) {
    return state.typeExportPdf;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
